module.exports = __webpack_public_path__ + "static/media/contract.9c630a48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/contract.svg
// module id = 464
// module chunks = 0